import hsUpload from './index.vue'

hsUpload.install = function(Vue) {
  Vue.component(hsUpload.name, hsUpload)
}
export default hsUpload



// WEBPACK FOOTER //
// ./src/components/upload/index.js